
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M16.125 0H1.875A1.875 1.875 0 000 1.875v14.25A1.875 1.875 0 001.875 18h14.25A1.875 1.875 0 0018 16.125V1.875A1.875 1.875 0 0016.125 0zm-2.25 7.125H10.5a.75.75 0 110-1.5h3.375a.75.75 0 110 1.5zm.75 6a.75.75 0 01-.75.75H10.5a.75.75 0 110-1.5h3.375a.75.75 0 01.75.75zM8.475 4.2l-2.25 3a.75.75 0 01-.547.3h-.053a.75.75 0 01-.53-.22L3.97 6.155a.75.75 0 011.06-1.061l.514.514L7.275 3.3a.75.75 0 011.2.9zm0 7.5l-2.25 3a.763.763 0 01-1.13.08L3.97 13.655a.75.75 0 011.06-1.06l.514.513L7.275 10.8a.75.75 0 011.2.9z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    